import { appConfig } from 'brand-config';

/**
 * Attaching Renters to an Auto policy — the "Renters Coverage" section (toggle + address + coverage
 * fields) on the policy Details → Auto screen — is a Branch-only capability. CFM never sold Renters,
 * yet the toggle rendered for every brand and its agents kept selecting it by mistake (#35383). The
 * brand flag `featureFlags.offerRentersOnAuto` is on for Branch and off for everyone else, so the
 * `<Renters>` section only renders where the brand actually writes the coverage. Forreston and Oakwood
 * write no auto line at all, so they carry no entry and read falsy here.
 */
export const shouldOfferRentersOnAuto = () => Boolean(appConfig?.featureFlags?.offerRentersOnAuto);
